export enum PageType {
  OrderedPage = `orderedPage`,
  MicrositeOrderedPage = `micrositeOrderedPage`,
  PagePpArticle = `pagePpArticle`,
}
